import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UcrTextModule } from '../../db-text/ucr-text.module';
import { EmailModule } from '../../email/email.module';
import { UcrFormsModule } from '../../forms/ucrforms.module';
import { SharedModule } from '../../shared/shared.module';
import { TablesModule } from '../../tables/tables.module';
import { EmailAddressService } from './email-address.service';
import { EmailTemplateAuditTrailComponent } from './email-template-audit-trail/email-template-audit-trail.component';
import { EmailTemplateEditComponent } from './email-template-edit/email-template-edit.component';
import { EmailTemplateFilterService } from './email-template-filter.service';
import { EmailTemplateListComponent } from './email-template-list/email-template-list.component';
import { EmailTemplateHeaderFooterComponent } from './email-template-header-footer/email-template-header-footer.component';
import { EmailAddressEditComponent } from './email-address-edit/email-address-edit.component';
import { EmailAddressListComponent } from './email-address-list/email-address-list.component';

@NgModule({
    declarations: [
        EmailTemplateListComponent,
        EmailTemplateAuditTrailComponent,
        EmailTemplateEditComponent,
        EmailTemplateHeaderFooterComponent,
        EmailAddressEditComponent,
        EmailAddressListComponent
    ],
    exports: [EmailTemplateListComponent, EmailAddressListComponent],
    imports: [
        CommonModule,
        MatPaginatorModule,
        MatTableModule,
        MatIconModule,
        MatSortModule,
        MatTooltipModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        SharedModule,
        MatCardModule,
        MatSelectModule,
        MatProgressBarModule,
        MatDialogModule,
        MatTabsModule,
        MatExpansionModule,
        EmailModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatChipsModule,
        UcrFormsModule,
        TablesModule,
        UcrTextModule
    ],
    providers: [DatePipe, EmailTemplateFilterService, EmailAddressService]
})
export class EmailTemplateModule {}
